export default "__VITE_ASSET__CTgUB8gF__"